import { Link, useHistory } from "react-router-dom";
import { Badge, Box, Button, Card, Tab, Tabs } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import List from "./List";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import Room from "./Room";
import TabBoxComponent from "../UI/TabBox";
import moment from "moment";

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 0 }}>{children}</Box>}
    </div>
  );
}
const MeetingListComponent = (props) => {
  const {
    meetings,
    GetAllMeetings,
    GetAllInvitedIn,
    location,
    invitedIn,
    notification,
    MarkAsRead,
    settings,
    systemSettings
  } = props;
  const [selected, setSelected] = useState(location?.state?.status ?? "All");
  const [value, setValue] = useState(location?.state?.tab ?? 0);
  const [selectedTab, setSelectedTab] = useState(0);
  const mainBackground = systemSettings?.mainBackground;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const history = useHistory();
  const handleScheduleNewClick = () => {
    history.push("/admin/schedule-meeting");
  };
  const meetingNotification =
    notification?.filter((notif) => notif?.content?.type === "meeting") ?? [];
  const minuteNotification =
    notification?.filter((notif) => notif?.content?.type === "minutes") ?? [];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 1) {
      history.push("/admin/meeting", { state: { tab: 1 } });
    }
  };
  return (
    <div className="">
      <div className="flex justify-between items-center">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item pageTitle"></li>
          </ol>
        </nav>
        <div className="row justify-content-end">
          <div className="col-md-5 flex justify-end ">
            <div className={"flex-grow-1 me-2"}></div>
            <div className={"me-2"}>
              <Link
                to="/admin/meeting"
                className={"text-decoration-none"}
              ></Link>
            </div>
            <div className="ml-2">
              <Link
                to="/admin/minutes"
                className={"text-decoration-none"}
              ></Link>
            </div>
          </div>
        </div>
      </div>
      <Card className={"overflow-auto mt-3 "} variant={"outlined"}>
        <div className={"card-body mt-0 pt-0"}>
          {/* <div className="row group-btn">
            <div className="col-md-7"></div>
            <h1 className="ml-2 p-3 font-semibold text-sm">Meetings Calendar</h1>
          </div> */}
          <Box
            sx={{ borderBottom: 1, borderColor: "divider" }}
            className="flex flex-col p-3"
          >
            <div className="flex justify-between items-center">

              <TabBoxComponent

                selectedValue={selectedTab}
                handleTabChange={handleTabChange}

                tabList={[
                  {
                    label: "Meeting",
                    tabValue: 0,
                    permissionCode: "submenu.meeting_room",
                    // permissionCode: "menu.meeting",
                  },
                  {
                    label: "My Schedule",
                    tabValue: 1,
                    permissionCode: "menu.meeting",
                  },
                  {
                    label: "Incoming",
                    tabValue: 2,
                    // permissionCode: "submenu.incoming",
                    permissionCode: "menu.meeting",
                  },
                ]}
              />

              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >{selectedTab === 1 && (
                <Tab
                  label={
                    <span className="flex items-center">
                      <AddIcon className="mr-2" />
                      Add new
                    </span>
                  }
                  {...a11yProps(2)}
                  onClick={handleScheduleNewClick}
                  sx={{
                    backgroundColor: mainBackground,
                    color: "white",
                    borderRadius: "4px",
                    padding: "8px 16px",
                    "&:hover": { backgroundColor: "#336767" },
                    "&.Mui-selected": {
                      backgroundColor: mainBackground,
                      color: "white",
                    },
                  }}
                />
              )}
              </Tabs>
            </div>
          </Box>
          {selectedTab === 0 && (
            <TabPanel value={selectedTab} index={0}>
              <Room SetSelectedMenu={(menu) => console.log(menu)} />
            </TabPanel>
          )}
          {selectedTab === 1 && (
            <TabPanel value={selectedTab} index={1}>
              <List
                meetings={meetings.map((meeting) => ({
                  ...meeting,
                  start: moment(meeting.start).utc().format("YYYY-MM-DD HH:mm"),
                  end: moment(meeting.end).utc().format("YYYY-MM-DD HH:mm"),
                }))}
                selected={selected}
                type={"my-schedule"}
                setSelected={setSelected}
                GetAllMeetings={GetAllMeetings}
                settings={settings}
                notification={notification}
                MarkAsRead={MarkAsRead}
              />
            </TabPanel>
          )}
          {selectedTab === 2 && (
            <TabPanel value={selectedTab} index={2}>
              <List
                meetings={meetings}
                selected={selected}
                type={"invited-in"}
                setSelected={setSelected}
                GetAllMeetings={GetAllInvitedIn}
                settings={settings}
                notification={notification}
                MarkAsRead={MarkAsRead}
              />
            </TabPanel>
          )}
        </div>
      </Card>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MeetingListComponent)
